// extracted by mini-css-extract-plugin
export default {"container":"Counter_container__4R5Qq","card":"Counter_card__K2Iko"};